export default __webpack_public_path__ + "static/media/You_re a Hindrance.58a3d081.png";